import React from 'react'
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'
import WhatsAppShareButton from '../Components/WhatsAppShareButton'

const RecentRecommendations = () => {

  const { data, error, isLoaded } = GetRequest("/Recommendation/GetRecentRecommandationsNotExpired");

  if (error !== null) return <Error data=" " />;
  if (!isLoaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="card card-warning">
            <div className="card-header widget-user-header" id="accordionRecentRecommendationHeader">
              <h6 className="widget-user-username" data-bs-toggle="collapse" href='#collapseRecentRecommendationBody'>
                Booster Recommendations
                <i className="fa fa-angle-down dp-right-mt5"></i>
              </h6>
            </div>

            <div className="card-body no-padding collapse show" id="collapseRecentRecommendationBody" data-bs-parent="#accordionRecentRecommendationHeader">
              <ul className="nav flex-column">
                <div id="accordionRecentRecommendationList">
                  {
                    data.result && data.result.map(item => (
                      <div className="card card-success mb-3" key={item.id}>
                        <div
                          className="card-header d-flex justify-content-between align-items-center text-white"
                          data-bs-toggle="collapse"
                          href={`#collapseRecentRecommendation${item.id}`}
                          style={{ cursor: 'pointer', background: 'linear-gradient(to right, #56ab2f, #a8e063)' }}
                          data-bs-parent="#accordionRecentRecommendationList"
                        >
                          <div>
                            <i className="fa fa-lightbulb me-2"></i>
                            <strong>{item.title}</strong>
                          </div>
                          <i className="fa fa-chevron-down rotate-icon"></i>
                        </div>

                        <div id={`collapseRecentRecommendation${item.id}`} className="collapse">
                          <div className="card-body no-padding px-3 py-2">
                            <p className='pdetls'>
                              <b>Problems:</b> {item.fieldProblemTitle}
                              <WhatsAppShareButton message={item.messageForSharing} />
                              <br />
                              <b>Problem Type:</b> {item.problemGroupTitle} <br />
                              <b>Suggestions:</b> {item.suggestion}.<br />
                            </p>

                            {
                              item.recommendedProductLines && item.recommendedProductLines.length > 0 && (
                                <>
                                  <h6 className='subTitle sinleIconDisplay mt-3'>Recommended Product</h6>
                                  {
                                    item.recommendedProductLines.map((prod, index) => (
                                      <div key={index} className="pdetls mb-2">
                                        <b>Product Name:</b> {prod.productName} <br />
                                        <b>Dosage Per Pump:</b> {prod.dosageInformationPerPump} <br />
                                        <b>Dosage Per Acre:</b> {prod.dosageInformationPerAcre} <br />
                                        <b>Comments:</b> {prod.comments} <br />
                                        <div className='col-12 combineProductIcon'>
                                          <i className="fa fa-plus PlusIcon"></i>
                                        </div>
                                      </div>
                                    ))
                                  }
                                </>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Optional: Style for rotating icon */}
      <style>{`
        .rotate-icon {
          transition: transform 0.3s ease;
        }
        .card-header.collapsed .rotate-icon {
          transform: rotate(0deg);
        }
        .card-header:not(.collapsed) .rotate-icon {
          transform: rotate(180deg);
        }
      `}</style>
    </>
  )
}

export default RecentRecommendations;
